import { render, staticRenderFns } from "./ServicosEditar.vue?vue&type=template&id=381aef89&scoped=true&"
import script from "./ServicosEditar.vue?vue&type=script&lang=js&"
export * from "./ServicosEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381aef89",
  null
  
)

export default component.exports